import React from "react";
import { Icon } from "@iconify/react";
import "./MyCart.css";
import Mycartcontent from "./Mycartcontent";
import Footer from "../small/Footer";
import { Link } from "react-router-dom";
function MyCart() {
  return (
    <div>
      <div className="whole-main">
        <section className="my-cart">
          <div className="container">
            <div className="my-cart-heading d-flex">
              [
              <Icon
                icon="ic:outline-add-shopping-cart"
                height={40}
                color="white"
                className="mlr-10"
              />
              <h1 className="mar-10 ">My Cart</h1>]
            </div>

            <Mycartcontent />
            <Mycartcontent />
            <Mycartcontent />

            <div className="checkoutBtn">
              <Link to="/checkout">Checkout</Link>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default MyCart;
